import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'redux/store';
import { closeEditTranslationComponent, translationUpdate } from 'redux/actions/edit-translations';
import { TranslationInfo } from 'redux/schemas/models/edit-translations';
import { NLectureComponent } from 'redux/schemas/models/lecture-component';
import { getCurrentUser } from 'redux/selectors/users';

import { getLectureComponent } from 'redux/selectors/lecture-components';
import EditableSimpleInput from './base/editable-simple-input';

type EditableProps = {
  editInfo: TranslationInfo,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableSimpleComponent = ({
  editInfo,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const lectureComponent = useSelector((state) => (
    getLectureComponent(state, editInfo.id)
  )) as NLectureComponent;
  const name = Object.keys(lectureComponent.translationIds)[0];
  const [value, setValue] = useState(lectureComponent[name]);
  const currentUser = useSelector(getCurrentUser);
  const dispatch = useAppDispatch();

  const save = useCallback(() => {
    const { id } = editInfo;
    const payload = {
      id,
      attributes: [
        {
          translationId: lectureComponent.translationIds[name],
          name,
          text: value,
          elementType: editInfo.type,
        },
      ],
    };
    dispatch(translationUpdate(payload)).then(() => {
      dispatch(closeEditTranslationComponent());
    });
  }, [currentUser.translationPreferenceLanguage, dispatch, editInfo, value]);

  useEffect(() => {
    onSaveRef(() => save);
  }, [onSaveRef, save]);

  useEffect(() => {
    if (lectureComponent[name] !== value) {
      setSavingDisabled(false);
    }
    return (() => {
      setSavingDisabled(true);
    });
  }, [value]);

  return (
    <EditableSimpleInput value={value} setValue={setValue} />
  );
};

export default EditableSimpleComponent;
